/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: linxi
 * @LastEditTime: 2023-02-22 14:06:56
 */
/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: sj
 * @LastEditTime: 2022-08-11 11:08:08
 */
import { SwapRightOutlined } from '@ant-design/icons'
import { Popconfirm, Space, TableColumnType, Tooltip } from 'antd'
import React, { ReactElement } from 'react'
import { PushpinLine } from '../../compnents/icons/Icons'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { Tenant } from '../../models/tenant'
import { ThemeData } from '../../theme/ThemeContext'
import styles from './ReplaceMakeSupplier.module.css'

export const columns = (
  onClick: (type: 'toggle' | 'partner' | 'herbs', tenant: any) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '代煎饮片厂名称',
      key: 'name',
      align: 'center',
      dataIndex: 'name',
      width: '15rem',
      ellipsis: true,
    },
    {
      title: '代煎类别',
      key: 'decoctionType',
      align: 'center',
      dataIndex: 'decoctionType',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '加工方式',
      key: 'machiningType',
      align: 'center',
      width: '30rem',
      ellipsis: true,
      dataIndex: 'machiningType',
      // render: function MachiningType(_, t: any): ReactElement {
      //   return (
      //     <div
      //       style={{
      //         wordWrap: 'break-word',
      //         wordBreak: 'break-word',
      //         whiteSpace: 'normal',
      //       }}
      //     >
      //       {_}
      //     </div>
      //   )
      // },
    },
    {
      title: '创建时间',
      key: 'createTime',
      align: 'center',
      dataIndex: 'createTime',
      width: '10rem',
      ellipsis: true,
    },
    {
      title: '供应商状态',
      key: 'status',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: function Status(_, t): ReactElement {
        const active = t.status === 0
        return (
          <StateSwitch value={active} onChange={() => onClick('toggle', t)} />
        )
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '10em',
      render: function ActionBar(_, t): ReactElement {
        return (
          <Space>
            <a onClick={() => onClick('partner', t)}>查看合作机构 </a>
            <a onClick={() => onClick('herbs', t)}>商品目录 </a>
          </Space>
        )
      },
    },
  ]
}

export const supplierColumns = (): TableColumnType<any>[] => {
  //代煎药材目录
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: '渠道商名称',
      align: 'center',
      dataIndex: 'placeName',
    },
    {
      title: 'code',
      align: 'center',
      dataIndex: 'code',
    },
    {
      title: 'apiKey',
      align: 'center',
      dataIndex: 'apiKey',
    },
    {
      title: 'secretKey',
      align: 'center',
      dataIndex: 'secretKey',
    },
    {
      title: '创建时间',
      align: 'center',
      dataIndex: 'createTime',
    },
  ]
}
export const herbsListColumns = (
  //代煎饮片厂-商品目录
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '药品名称',
      align: 'center',
      dataIndex: 'drugName',
      render: function Element(_, t) {
        return t.flag == 1 ? (
          <>
            <Tooltip
              color={'#027aff'}
              title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{t.lastSupplyPrice?.toFixed(2)}</span>
                  <span style={{ margin: '0 5px' }}>
                    <SwapRightOutlined />
                  </span>
                  <span>{t.supplyPrice?.toFixed(2)}</span>
                </div>
              }
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <span style={{ marginRight: 5 }}>{t.drugName}</span>
                <span style={{ fontSize: '26px' }}>
                  <PushpinLine />
                </span>
              </div>
            </Tooltip>
          </>
        ) : (
          <>{t.drugName}</>
        )
      },
    },
    {
      title: '建议零售价',
      align: 'center',
      dataIndex: 'retailPrice',
      render: (_, r) => r.retailPrice?.toFixed(2),
    },
    {
      title: '供货价',
      align: 'center',
      dataIndex: 'supplyPrice',
      render: (_, r) => r.supplyPrice?.toFixed(2),
    },
  ]
}
export const herbsColumns = (
  onClick: (type: string, tenant: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '饮片厂药品名称',
      align: 'center',
      dataIndex: 'potionDrugName',
    },
    {
      title: '机构药品名称',
      align: 'center',
      dataIndex: 'tenantDrugName',
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '10em',
      render: function ActionBar(_, t): ReactElement {
        return (
          <Space>
            <a onClick={() => onClick('edit', t)}>编辑</a>
            <Popconfirm
              title='是否确认删除'
              onConfirm={() => onClick('delete', t)}
              okText='确认'
              cancelText='取消'
            >
              <a style={{ color: 'red' }}>删除</a>
            </Popconfirm>
          </Space>
        )
      },
    },
  ]
}
